import { classNamesFunction, ILinkStyles, IStackStyles, IStyle } from '@fluentui/react';
import { getSourceAppFromUrl } from '../../../../web/utils/statelessUtil';
import { getThemeFromUrl } from '../../../utilities';
import { color, IThemedProp } from './themesUI';

export interface IAutoSuggestCardStyles {
  root: IStyle;
  list: IStyle;
  header: IStyle;
  icon: IStyle;
  linkContainer: IStyle;
}

export interface IAutoSuggestCardComponentProps {
  transparentBackground: boolean;
}
type IAuthoSuggestStyleProps = IAutoSuggestCardComponentProps & IThemedProp;
export const getAutoSuggestCardStyles = (
  props: IAuthoSuggestStyleProps
): IAutoSuggestCardStyles => {
  const { theme, transparentBackground } = props;

  const rootWhite = theme ? theme.palette.white : color.white;

  return {
    root: {
      marginTop: '15px',
      color: theme.palette.neutralPrimary,
      fontSize: '14px',
      lineHeight: '2',
      fontFamily: "'Segoe UI',SegoeUI,'Helvetica Neue',Arial,sans-serif",
    },
    header: {
      fontWeight: '600',
      fontSize: '19px',
    },
    list: {
      background: transparentBackground ? null : rootWhite,
      padding: transparentBackground ? '10px' : 0,
    },
    icon: {
      marginRight: '5px',
      color: theme.semanticColors.link,
      fontSize: '11px',
    },
    linkContainer: {
      display: 'block',
      background: ((getSourceAppFromUrl(window.location.href) === 'surfaceapp1' || getSourceAppFromUrl(window.location.href) === 'surfaceapp2') && !transparentBackground) ? (getThemeFromUrl() === 'darkgray' ? '#202020' : '#f3f3f3') : null,
    },
  };
};

export const getAutoSuggestCardLinkStyles = (
  props: IThemedProp
): Partial<ILinkStyles> => {
  const { theme } = props;
  return {
    root: {
      margin: 0,
      padding: 0,
      color: theme.semanticColors.link,
      maxWidth: '90%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      '&:hover': {
        color: theme.semanticColors.link,
      },
    },
  };
};

export interface IAutoSuggestSuggestListStyles {
  supAutoSuggestContainer: IStyle;
  socSuggestionList: IStyle;
  supSuggestionList: IStyle;
  supSuggestionItem: IStyle;
  supSuggestionItemHighlight: IStyle;
}

export const getAutoSuggestListStyles = (props: IThemedProp): IAutoSuggestSuggestListStyles => {
  const { theme } = props;
  return {
    supAutoSuggestContainer: {
      backgroundColor: theme.semanticColors.inputBackground,
      position: 'absolute',
      width: '100%',
      zIndex: '10000',
      border: '1px solid #a9a9a9',
      borderTop: 'none',
    },
    socSuggestionList: {
      paddingLeft: '0',
    },
    supSuggestionList: {
      marginTop: '1px',
      listStyleType: 'none',
    },
    supSuggestionItem: {
      listStyleType: 'none',
      padding: '4px 20px',
      cursor: 'pointer',
      textAlign: 'left',
      lineHeight: '20px',
      textIndent: '-10px',
      fontSize: '14px',
      color: theme.palette.neutralPrimary,
      ':hover': {
        backgroundColor: theme.palette.neutralLighter,
        color: theme.palette.neutralPrimary,
      },
      ':focus': {
        backgroundColor: theme.palette.neutralLighter,
        color: theme.palette.neutralPrimary,
      },
    },
    supSuggestionItemHighlight: {
      backgroundColor: theme.palette.neutralLighter,
      color: theme.palette.neutralPrimary,
    },
  };
};

export const RelatedQueriesContainerStyle = (backgroundColor: string): IStackStyles => ({
  root: {
    background: backgroundColor,
    zIndex: 1,
    justifyContent: 'flex-start',
  },
});

export const RelatedQueriesSearchIconStyle: IStackStyles = {
  root: {
    marginRight: '8px',
  },
};

export const getHelpSearchRelatedQueriesLinkStyle = (textColor: string): Partial<ILinkStyles> => ({
  root: {
    paddingTop: '8px',
    paddingBottom: '8px',
    width: '100%',
    color: textColor,
    fontSize: '14px',
    fontWeight: 400,
    selectors: {
      '&:hover, &:focus': {
        cursor: 'pointer',
        color: textColor,
      },
    },
  },
});

export const getAutoSuggestCardClassNames = classNamesFunction<
  {},
  IAutoSuggestCardStyles
>();

export const getAutoSuggestListclassNames = classNamesFunction<{}, IAutoSuggestSuggestListStyles>();
